import React from 'react';
import View from './view';
import { useGetConfluenceViewContext } from '../../containers/get-confluence-view';

const PreprovisionLandingContainer = () => {
	const getConfluenceViewContext = useGetConfluenceViewContext();
	if (!getConfluenceViewContext) {
		throw new Error('PreprovisionLandingContainer must be used within GetConfluenceViewProvider');
	}

	const { onViewed, primaryAction } = getConfluenceViewContext;

	return <View onTryClick={primaryAction.onClick} onViewed={onViewed} />;
};

export default PreprovisionLandingContainer;
